function submitForm() {
  const agencyCreationsForm = document.querySelector<HTMLFormElement>(
    '#agency_creation_form',
  )
  if (agencyCreationsForm) {
    agencyCreationsForm.submit()
  }
}

function initAgencyCreate() {
  document.addEventListener('htmx:afterRequest', function (_) {
    const modalFooterSubmitBtn = document.querySelector<HTMLButtonElement>(
      '#modal-footer-submit',
    )
    if (modalFooterSubmitBtn) {
      modalFooterSubmitBtn.onclick = () => {
        modalFooterSubmitBtn.disabled = true
        submitForm()
      }
    }
  })
}

export { initAgencyCreate }
